import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../../AppContext';

const Services = () => {
    const { appState } = useContext(AppContext);
    const { header, description, items, title, buttonHeaderText, link } = appState.services || {};


    if (!items?.[0]) {
        return
    }


    return (
        <section className="main-services section-padding p-relative" id={'services'}>
            {/* <div className="side-lines">
                <span className="box" />
                <span className="text">{title}</span>
                <span className="line" />
            </div> */}
            <div className="container">
                <div className="section-header">
                    <div className="section-heading" style={{
                        marginLeft: 60
                    }}>
                        <h3 className="text-custom-black fw-700">{header}</h3>
                        <div className="section-description">
                            <p className="text-light-white">{description}</p>
                        </div>
                    </div>
                    <div className="section-btn">
                        <Link
                            to={"/"}
                            onClick={() => {
                                window.open(link, '_self')
                            }}
                            // to="/service"
                            className="btn-first btn-submit text-light-blue">
                            {buttonHeaderText}
                        </Link>
                    </div>
                </div>
                <div className="row">
                    <ServicesGrid items={items} />
                    {/* {items.map((item, i) => (
                        <div key={i} className="col-lg-3 col-sm-6" onClick={() => {
                            window.open(item?.link, '_self')
                        }}>
                            <div className="main-services-box p-relative mb-xl-30">
                                <div className="main-service-wrapper padding-20">
                                    <div className="icon-box">
                                        <i className={`fas ${item.icon}`} />
                                    </div>
                                    <h5 className="fw-700">
                                        <Link
                                            // to={`/service-detail/${item.id}`} 
                                            // onClick={() => {
                                            //     window.open(item?.link, '_self')
                                            // }}

                                            className="text-custom-black">
                                            {item.title}
                                        </Link>
                                    </h5>
                                    <p className="text-light-white no-margin">{item.shortdesc}</p>
                                </div>
                            </div>
                        </div>
                    ))} */}
                </div>
            </div>
        </section>
    );
};

export default Services;

// Helper to map titles to Font Awesome icons
const getFontAwesomeIcon = (title = '') => {
    title = title.toLowerCase();
    if (title.includes('loan') && title.includes('car')) return 'fa-car';
    if (title.includes('loan') && title.includes('home')) return 'fa-home';
    if (title.includes('loan') && title.includes('personal')) return 'fa-user';
    if (title.includes('credit')) return 'fa-credit-card';
    return 'fa-star'; // default
};


const ServicesGrid = ({ items }) => {
    return (
        <>
            {items.map((item, i) => (
                <div key={i} className="col-lg-3 col-sm-6" onClick={() => window.open(item?.link, '_self')}>
                    <div className="main-services-box p-relative mb-xl-30">
                        <div className="main-service-wrapper padding-20">
                            <div className="icon-box">
                                {/* Use Font Awesome equivalents */}
                                <i className={`fas ${item.icon}`} />
                            </div>
                            <h5 className="fw-700">
                                <Link to={item.link} className="text-custom-black">
                                    {item.title}
                                </Link>
                            </h5>
                            <p className="text-light-white no-margin">{item.shortdesc}</p>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};